<template>
  <view-wrapper
    :show-back-button="false"
    name="My labels"
    :loading="loading"
    loading-text="Getting labels"
  >
    <div class="float-right">
      <g-button
        v-if="quickPrintReady"
        class="ml-4 primary"
        @click="quickPrint()"
        >QuickPrint</g-button
      >
    </div>

    <filter-and-sort-box :data="labels" :headers="headers">
      <template v-slot:d="{ d }">
        <td
          class="relative py-1"
          v-for="(key, index) in getKeys(d)"
          :key="key + index"
          v-bind:style="
            !features.showFeatures.myLabels.printOrderEnabled &&
            !features.showFeatures.myLabels.printArticleEnabled
              ? 'cursor:pointer'
              : ''
          "
          @click="
            {
              !features.showFeatures.myLabels.printOrderEnabled &&
              !features.showFeatures.myLabels.printArticleEnabled
                ? selectOrder(d)
                : null;
            }
          "
        >
          <div
            class="w-full py-4 pl-4 bg-primary-light"
            v-if="Array.isArray(d[key])"
          >
            <span v-for="(item, index) in d[key]" :key="index">
              {{ item.name }}<span v-if="index < d[key].length - 1">,</span>
            </span>
          </div>
          <div
            class="w-full py-4 pl-4 bg-primary-light"
            :class="{
              'rounded-l': index === 0,
              'rounded-r': Object.keys(headers).length - 1 === index,
            }"
            v-else
          >
            <span v-if="key != 'modified'" class="inline-block w-10/12">{{
              d[key] ? d[key] : ""
            }}</span>
            <span v-if="key == 'modified'" class="inline-block w-10/12">{{
              d[key] ? formatDate(d[key]) : ""
            }}</span>
          </div>
        </td>
        <td
          class="relative py-1"
          v-if="
            features.showFeatures.myLabels.printOrderEnabled ||
              features.showFeatures.myLabels.printArticleEnabled
          "
        >
          <div class="flex justify-end pr-4 rounded-r bg-primary-light">
            <router-link
              v-if="features.showFeatures.myLabels.printOrderEnabled"
              :to="`print-labels/${d.id}`"
              class="py-4 font-bold underline text-highlight"
              >Orders</router-link
            >
            <router-link
              v-if="features.showFeatures.myLabels.printArticleEnabled"
              :to="`print-labels/${d.id}/articles`"
              class="py-4 font-bold underline text-highlight"
              :class="features.showFeatures.myLabels.printOrderEnabled ? 'ml-4' : ''"
              >Articles</router-link
            >
          </div>
        </td>
      </template>
    </filter-and-sort-box>
  </view-wrapper>
</template>

<script>
import FilterAndSortBox from "../../components/FilterAndSortBox";
import GButton from "../../components/forms/Button";
import { formatDate } from "../../utils/dateHelpers";
export default {
  components: {
    FilterAndSortBox,
    GButton,
  },
  data: () => ({
    quickPrintReady: false,
    loading: false,
    labels: [],
    headers: {
      name: "Label name",
      modified: "Modified",
    },
    features: {},
  }),
  methods: {
    async getQuickPrintReadyStatus() {
      if (!this.features.quickPrintEnabled) return;

      const response = await this.$store.$api.get("/api/articles/quickprint");
      const data = response.data.data;
      this.quickPrintReady = Array.isArray(data) && data.length;
    },
    async getLabels() {
      this.loading = true;
      const response = await this.$store.$api.get("/api/labels/list");
      this.labels = response.data.data
        .filter(l => !l.disabled)
        .map(l => {
          return {
            id: l.labelId,
            name: l.name,
            modified: l.modified,
          };
        });
      this.loading = false;
    },
    getKeys(label) {
      return Object.keys(label).filter(key => {
        return key !== "id";
      });
    },
    formatDate: formatDate,
    quickPrint() {
      this.$router.push(`quickprint`);
    },
    async getEnabledFeatures() {
      const response = await this.$store.$api.get("/api/features");
      this.features = response.data.data;
    },
  },
  async mounted() {
    await this.getEnabledFeatures();
    await this.getLabels();
    await this.getQuickPrintReadyStatus();
  },
};
</script>
